import { v4 as uuidv4 } from "uuid";
import { generateStaticQuestionId } from "../../../../../utils/goalsUtils";

export const coachingDirector = {
    "blockId": uuidv4(),
    "description": "<p>Scales capacity by maximizing the performance and potential of future talent. Engages to enable direct and meaningful feedback that empowers skill development and realization of potential.</p>",
    "goalId": "dynamic360Strength",
    isRequired: true,
    feedbackBasedCondition: [
        {
            answeringCondition: [
                {
                    columnValues: ["1", "2"],
                    numberOfAnswersNeeded: 3,
                },
                {
                    columnValues: ["3", "4"],
                    numberOfAnswersNeeded: 3,
                },
                {
                    columnValues: ["5", "6"],
                    numberOfAnswersNeeded: 3,
                }
            ]
        }

    ],
    allowNAOption: true,
    "questions": [
        {
            "question": "",
            "options": [
                {
                    "label": "Never",
                    "value": "1"
                },
                {
                    "label": "Rarely",
                    "value": "2"
                },
                {
                    "label": "Occasionally",
                    "value": "3"
                },
                {
                    "label": "Sometimes",
                    "value": "4"
                },
                {
                    "label": "Usually",
                    "value": "5"
                },
                {
                    "label": "Always",
                    "value": "6"
                },
                { "label": "Can't answer", "value": "0" }
            ],
            "questionDimension": "Custom Matrix",
            "type": "matrix",
            "qid": uuidv4(),
            "matrixQuestions": [
                {
                    "subCategoryId": generateStaticQuestionId("Drive High Velocity Performance"),
                    "subCategory": "Drive High Velocity Performance",
                    "staticQuestionId": generateStaticQuestionId("Holds teams and individual members accountable for achieving high-quality results"),
                    "HTMLText": "<p>Holds teams and individual members accountable for achieving high-quality results</p>",
                    "isSelected": true,
                    "text": "Holds teams and individual members accountable for achieving high-quality results",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Drive High Velocity Performance"),
                    "subCategory": "Drive High Velocity Performance",
                    "staticQuestionId": generateStaticQuestionId("Supports balance between high intensity work and recovery"),
                    "HTMLText": "<p>Supports balance between high intensity work and recovery</p>",
                    "isSelected": true,
                    "text": "Supports balance between high intensity work and recovery",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Drive High Velocity Performance"),
                    "subCategory": "Drive High Velocity Performance",
                    "staticQuestionId": generateStaticQuestionId("Communicates strategic direction and involves team members in developing and implementing plans"),
                    "HTMLText": "<p>Communicates strategic direction and involves team members in developing and implementing plans</p>",
                    "isSelected": true,
                    "text": "Communicates strategic direction and involves team members in developing and implementing plans",
                    "value": uuidv4()
                },

                {
                    "subCategoryId": generateStaticQuestionId("Optimize Potential Realization"),
                    "subCategory": "Optimize Potential Realization",
                    "staticQuestionId": generateStaticQuestionId("Inspires team members to continuously elevate performance"),
                    "HTMLText": "<p>Inspires team members to continuously elevate performance</p>",
                    "isSelected": true,
                    "text": "Inspires team members to continuously elevate performance",
                    "value": uuidv4()
                },

                {
                    "subCategoryId": generateStaticQuestionId("Optimize Potential Realization"),
                    "subCategory": "Optimize Potential Realization",
                    "staticQuestionId": generateStaticQuestionId("Proactively assigns work that stretches and develops team members' capabilities"),
                    "HTMLText": "<p>Proactively assigns work that stretches and develops team members' capabilities</p>",
                    "isSelected": true,
                    "text": "Proactively assigns work that stretches and develops team members' capabilities",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Optimize Potential Realization"),
                    "subCategory": "Optimize Potential Realization",
                    "staticQuestionId": generateStaticQuestionId("Provides on-going and timely coaching to support personal and professional growth"),
                    "HTMLText": "<p>Provides on-going and timely coaching to support personal and professional growth</p>",
                    "isSelected": true,
                    "text": "Provides on-going and timely coaching to support personal and professional growth",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Feed-Forward With Candor"),
                    "subCategory": "Feed-Forward With Candor",
                    "staticQuestionId": generateStaticQuestionId("Challenges the status quo by identifying bold actions for implementation"),
                    "HTMLText": "<p>Challenges the status quo by identifying bold actions for implementation</p>",
                    "isSelected": true,
                    "text": "Challenges the status quo by identifying bold actions for implementation",
                    "value": uuidv4()
                },
              
                {
                    "subCategoryId": generateStaticQuestionId("Feed-Forward With Candor"),
                    "subCategory": "Feed-Forward With Candor",
                    "staticQuestionId": generateStaticQuestionId("Encourages team members to take initiative in determining how best to drive team outcomes"),
                    "HTMLText": "<p>Encourages team members to take initiative in determining how best to drive team outcomes</p>",
                    "isSelected": true,
                    "text": "Encourages team members to take initiative in determining how best to drive team outcomes",
                    "value": uuidv4()
                },
             
                {
                    "subCategoryId": generateStaticQuestionId("Feed-Forward With Candor"),
                    "subCategory": "Feed-Forward With Candor",
                    "staticQuestionId": generateStaticQuestionId("Initiates difficult conversations in a timely manner to drive optimal outcomes"),
                    "HTMLText": "<p>Initiates difficult conversations in a timely manner to drive optimal outcomes</p>",
                    "isSelected": true,
                    "text": "Initiates difficult conversations in a timely manner to drive optimal outcomes",
                    "value": uuidv4()
                },

              
              
               
            ],
            "questionLabel": "Custom Matrix"
        }
    ],
    "isSelected": true,
    "type": "matrix",
    "dimension": "Coaching"
}